import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import { Icon, List } from '@pella/sash-framework';
import { CTA } from '../../';

import ColumnMenu from './menu-types/column';
import ProductMenu from './menu-types/product';
import SupportMenu from './menu-types/support';

const MobileMenu = ({ data, isOpen }) => {
	const onMenuItemClick = (e) => {
		const menu = document.getElementById('js-mobileMenu');
		const parent = e.currentTarget.parentNode.parentNode;
		const siblings = e.currentTarget.parentNode.childNodes;

		if (siblings && siblings.length > 1) {
			parent.scrollTop = 0;
			menu.classList.add('overflow-hidden');
			siblings[1].classList.add('!right-0');
		}
	};

	return (
		<nav
			id='js-mobileMenu'
			className={`pal-mobileNav fixed top-0 z-8 h-[calc(100vh-65px)] w-full overflow-y-auto overflow-x-hidden bg-white pb-8 motion-safe:transition-all motion-safe:duration-500 sm:top-[65px] sm:w-[320px] sm:pb-5 xl:hidden ${isOpen ? 'visible right-0' : 'invisible -right-full md:-right-80'}`}
			aria-label='Mobile Nav'
		>
			<List
				bullets='none'
				className='pal-mobileNav-List'
			>
				{data.group?.[0] &&
					data.group.map((parent, index) => (
						<li key={index}>
							{parent.section?.[0] && (
								<button
									onClick={onMenuItemClick}
									className='relative block w-full border-b border-b-gray-20 bg-white p-4 text-left text-base font-semibold uppercase leading-tight tracking-2px text-black no-underline hover:text-blue focus:text-blue'
									data-title={parent.heading}
									aria-label='default'
								>
									{parent.heading}
									<Icon
										name='keyboard_arrow_right'
										className='absolute right-4 top-1/2 -translate-y-1/2'
										size={36}
									/>
								</button>
							)}

							{parent?.section?.[0] && (
								<>
									{parent.heading === 'Products' && (
										<ProductMenu
											data={parent.section}
											parent={parent.heading}
										/>
									)}
									{parent.heading === 'Getting Started' && (
										<ColumnMenu
											data={parent.section[0]}
											parent={parent.heading}
										/>
									)}
									{parent.heading.includes('Support') && (
										<SupportMenu
											data={parent.section[0]}
											parent={parent.heading}
										/>
									)}
								</>
							)}

							{parent.linkable_url && (
								<Link
									to={parent.linkable_url}
									className='relative block w-full border-b border-b-gray-20 bg-white p-4 text-left text-base font-semibold uppercase leading-tight tracking-2px text-black no-underline hover:text-blue focus:text-blue'
								>
									{parent.heading}
								</Link>
							)}
						</li>
					))}

				{data.global?.[0] &&
					data.global.map((cta, index) => (
						<li
							className={`mt-3 ${index > 0 ? 'mt-0' : ''}`}
							key={index}
						>
							<CTA
								data={cta}
								className='block px-4 py-1.5 text-base font-semibold decoration-transparent'
								renderAs='link'
							/>
						</li>
					))}
			</List>
		</nav>
	);
};

MobileMenu.propTypes = {
	data: PropTypes.object,
	isOpen: PropTypes.bool,
};

export default MobileMenu;
